// filepath: c:\dev\WebModule\src\ui\DealerUI\src\localization\modules\module-registry.ts
import { ITranslationModule } from '../interfaces';
import { AddressEditorModule } from '../webmodule-common/other/ui/address-editor-lang';
import { ApiResponseHandlerModule } from '../scripts/api/api-response-handler-lang';
import { AppClientPageModule } from '../scripts/dealer-franchisee/pages/app-client-lang';
import { AppClientsPageModule } from '../scripts/dealer-franchisee/pages/app-clients-lang';
import { AppConfigModule } from '../scripts/dealer-franchisee/app-config-lang';
import { AppHomeModule } from '../scripts/dealer-franchisee/pages/app-home-lang';
import { AppIndexModule } from '../webmodule-common/other/app-index-lang';
import { ApplicationInitializationModule } from '../scripts/dealer-franchisee/application-initialization-lang';
import { AppProjectPageModule } from '../scripts/dealer-franchisee/pages/app-project-lang';
import { AppProjectsPageModule } from '../scripts/dealer-franchisee/pages/app-projects-lang';
import { AppPurchaseOrderPageModule } from '../scripts/dealer-franchisee/pages/app-purchase-order-lang';
import { AppPurchaseOrdersPageModule } from '../scripts/dealer-franchisee/pages/app-purchase-orders-lang';
import { AppQuotePageModule } from '../scripts/dealer-franchisee/pages/app-quote-lang';
import { AppQuotesPageModule } from '../scripts/dealer-franchisee/pages/app-quotes-lang';
import { AppResourceBaseModule } from '../scripts/dealer-franchisee/pages/app-resource-base-lang';
import { AppSettingsPageModule } from '../scripts/dealer-franchisee/pages/app-settings-lang';
import { AppSupportInboxModule } from '../scripts/dealer-franchisee/pages/app-support-inbox-lang';
import { AuthenticateModalLitModule } from '../webmodule-common/other/ui/loginscreen/authenticate-modal-lit-lang';
import { AutoSaveNotifierModule } from '../webmodule-common/other/context/auto-save-notifier-lang';
import { BranchSwitchModule } from '../scripts/dealer-franchisee/pages/helpers/branch-switch-lang';
import { ClientContainerManagerModule } from '../scripts/clients/data/client-container-manager-lang';
import { ClientDetailViewModule } from '../scripts/clients/views/client-detail-view-lang';
import { ClientListTableModule } from '../scripts/clients/views/client-list-table-lang';
import { ClientPickerModule } from '../scripts/clients/views/client-picker-lang';
import { ClientSummaryPickerModule } from '../scripts/clients/views/client-summary-picker-lang';
import { ClientViewModule } from '../scripts/clients/views/client-view-lang';
import { ContactContainerManagerModule } from '../scripts/clients/data/contact-container-manager-lang';
import { ContactDetailViewModule } from '../scripts/clients/views/contact-detail-view-lang';
import { ContactListTableModule } from '../scripts/clients/views/contact-list-table-lang';
import { ContactPickerModule } from '../scripts/clients/views/contact-picker-lang';
import { ContactViewModule } from '../scripts/clients/views/contact-view-lang';
import { ContainerManagerModule } from '../webmodule-common/other/container-manager-lang';
import { ConversationHelperModule } from '../scripts/dealer-franchisee/conversation/conversation-helper-lang';
import { DashboardBranchMonthlyDeliveryPipelineModule } from '../scripts/dealer-franchisee/dashboard/widget/branch-monthly-delivery-pipeline-lang';
import { DashboardBranchMonthlyRevenueByStateModule } from '../scripts/dealer-franchisee/dashboard/widget/branch-monthly-revenue-bystate-lang';
import { DashboardBranchMonthlyRevenueModule } from '../scripts/dealer-franchisee/dashboard/widget/branch-monthly-revenue-lang';
import { DashboardBranchMonthlyRevenuePipelineModule } from '../scripts/dealer-franchisee/dashboard/widget/branch-monthly-revenue-pipeline-lang';
import { DashboardBranchMonthlyUserRevenueByStateModule } from '../scripts/dealer-franchisee/dashboard/widget/branch-monthly-user-revenue-bystate-lang';
import { DashboardFilterModule } from '../scripts/dealer-franchisee/dashboard/widget/dashboard-filter-lang';
import { DataEntryScreenBaseModule } from '../webmodule-common/other/ui/data-entry-screen-base-lang';
import { DealerFranchiseeClientContainerModule } from '../scripts/dealer-franchisee/clients/data/franchisee-client-container-lang';
import { DealerFranchiseeClientUiAdaptorModule } from '../scripts/dealer-franchisee/clients/client-ui-adaptor-lang';
import { DealerFranchiseeConversationWmBranchquoteSupportModule } from '../scripts/dealer-franchisee/conversation/wm-branchquote-support-lang';
import { DealerFranchiseeConversationWmConversationEntryDropzoneModule } from '../scripts/dealer-franchisee/conversation/wm-conversation-entry-dropzone-lang';
import { DealerFranchiseeConversationWmConversationEntryModule } from '../scripts/dealer-franchisee/conversation/wm-conversation-entry-lang';
import { DealerPageloadVerificationsModule } from '../scripts/api/dealer-pageload-verifications-lang';
import { DevelopmentErrorModule } from '../webmodule-common/other/development-error-lang';
import { AppFabricationJobPageModule } from '../scripts/dealer-franchisee/fabrication-jobs/pages/app-fabrication-job-lang';
import { AppFabricationJobsPageModule } from '../scripts/dealer-franchisee/fabrication-jobs/pages/app-fabrication-jobs-lang';
import { EventSourceModule } from '../scripts/api/event-source-lang';
import { FabricationJobDetailViewModule } from '../scripts/fabrication-jobs/views/fabrication-job-detail-view-lang';
import { FabricationJobItemFrameViewModule } from '../scripts/fabrication-jobs/views/fabrication-job-item-frame-view-lang';
import { FabricationJobItemsTableModule } from '../scripts/fabrication-jobs/views/fabrication-job-items-table-lang';
import { FabricationJobListViewModule } from '../scripts/fabrication-jobs/views/fabrication-job-list-view-lang';
import { FabricationJobPickerModule } from '../scripts/fabrication-jobs/views/fabrication-job-picker-lang';
import { FabricationJobSummaryTableModule } from '../scripts/fabrication-jobs/views/fabrication-job-summary-table-lang';
import { FormInputViewModule } from '../webmodule-common/other/ui/templateresult/form-input-view-lang';
import { FranchiseeAppIndexModule } from '../scripts/dealer-franchisee/franchisee-app-index-lang';
import { FranchiseeBranchEditorModule } from '../scripts/franchisee/editors/franchisee-branch-editor-lang';
import { FranchiseeBrandingViewModule } from '../scripts/franchisee/view/franchisee-branding-view-lang';
import { FranchiseeClientDetailViewModule } from '../scripts/dealer-franchisee/clients/views/franchisee-client-detail-view-lang';
import { FranchiseeClientListTableModule } from '../scripts/dealer-franchisee/clients/views/franchisee-client-list-table-lang';
import { FranchiseeClientListViewModule } from '../scripts/dealer-franchisee/clients/views/franchisee-client-list-view-lang';
import { FranchiseeConfigurationViewModule } from '../scripts/franchisee/view/franchisee-configuration-view-lang';
import { FranchiseeEngineeredToOrderViewModule } from '../scripts/dealer-franchisee/quotes/views/franchisee-engineered-to-order-lang';
import { FranchiseeInformationViewModule } from '../scripts/franchisee/view/franchisee-information-view-lang';
import { FranchiseePaymentProfileDetailViewModule } from '../scripts/dealer-franchisee/franchisee/view/franchisee-payment-profile-detail-view-lang';
import { FranchiseePaymentProfilePickerModule } from '../scripts/dealer-franchisee/franchisee/view/franchisee-payment-profile-picker-lang';
import { FranchiseeProjectDetailViewModule } from '../scripts/dealer-franchisee/projects/views/franchisee-project-detail-view-lang';
import { FranchiseeProjectDocumentViewModule } from '../scripts/dealer-franchisee/projects/views/franchisee-project-document-view-lang';
import { FranchiseeProjectManagerModule } from '../scripts/dealer-franchisee/projects/data/franchisee-project-manager-lang';
import { FranchiseeProjectResourceViewModule } from '../scripts/dealer-franchisee/projects/views/franchisee-project-resource-view-lang';
import { FranchiseeProjectViewModule } from '../scripts/dealer-franchisee/projects/views/franchisee-project-view-lang';
import { FranchiseePurchaseOrderDetailViewModule } from '../scripts/dealer-franchisee/purchase-orders/views/franchisee-purchase-order-detail-view-lang';
import { FranchiseePurchaseOrderSummaryTableModule } from '../scripts/dealer-franchisee/purchase-orders/views/franchisee-purchase-order-summary-table-lang';
import { FranchiseePurchaseOrderViewModule } from '../scripts/dealer-franchisee/purchase-orders/views/franchisee-purchase-order-view-lang';
import { FranchiseeQuoteAddressManagerModule } from '../scripts/dealer-franchisee/quotes/data/franchisee-quote-address-manager-lang';
import { FranchiseeQuoteCreateProjectModalModule } from '../scripts/dealer-franchisee/quotes/views/franchisee-quote-create-project-modal-lang';
import { FranchiseeQuoteDetailViewModule } from '../scripts/dealer-franchisee/quotes/views/franchisee-quote-detail-view-lang';
import { FranchiseeQuoteItemsViewModule } from '../scripts/dealer-franchisee/quotes/views/franchisee-quote-items-view-lang';
import { FranchiseeQuoteListViewModule } from '../scripts/dealer-franchisee/quotes/views/franchisee-quote-list-view-lang';
import { FranchiseeQuoteManagerModule } from '../scripts/dealer-franchisee/quotes/data/franchisee-quote-manager-lang';
import { FranchiseeQuoteSupportTicketViewModule } from '../scripts/dealer-franchisee/quotes/views/franchisee-support-ticket-editor-view-lang';
import { FranchiseeQuoteViewModule } from '../scripts/dealer-franchisee/quotes/views/franchisee-quote-view-lang';
import { FranchiseeStaffViewModule } from '../scripts/franchisee/view/franchisee-staff-view-lang';
import { FranchiseeStockViewModule } from '../scripts/franchisee/view/franchisee-stock-view-lang';
import { FranchiseeSupplierSettingsViewModule } from '../scripts/franchisee/view/franchisee-supplier-settings-view-lang';
import { FranchiseeV6BomViewerModule } from '../scripts/dealer-franchisee/quotes/views/v6/franchisee-v6-bom-viewer-lang';
import { FranchiseeV6QuoteViewModule } from '../scripts/dealer-franchisee/quotes/views/v6/franchisee-v6-quote-view-lang';
import { FranchiseeViewModule } from '../scripts/franchisee/view/franchisee-view-lang';
import { FreehandLineItemViewModule } from '../scripts/quotes/views/freehand-line-item-view-lang';
import { GeneratedPurchaseOrdersWidgetModule } from '../scripts/dealer-franchisee/dashboard/widget/generated-purchase-orders-widget-lang';
import { GooglePlaceAutocompleteModule } from '../webmodule-common/other/ui/maps/google-place-autocomplete-lang';
import { GraphicalFamilyResourcePickerModule } from '../scripts/picker/graphical-family-resource-picker-lang';
import { IconNotificationSignalModule } from '../webmodule-common/other/ui/icons/icon-notification-signal-lang';
import { IndexedDbWrapperModule } from '../webmodule-common/database/indexed-db-wrapper-lang';
import { IssuedQuotesWidgetModule } from '../scripts/dealer-franchisee/dashboard/widget/issued-quotes-widget-lang';
import { LineItemViewModule } from '../scripts/quotes/views/line-item-view-lang';
import { LitTableModule } from '../webmodule-common/components/table/lit-table-lang';
import { LitTableViewModule } from '../webmodule-common/other/ui/littable-view-lang';
import { ModalConfirmationModule } from '../webmodule-common/other/ui/modal-confirmation-lang';
import { ModalConfirmationReasonModule } from '../webmodule-common/other/ui/modal-confirmation-reason-lang';
import { ModalErrorHandlerModule } from '../webmodule-common/other/ui/modal-errorhandler-lang';
import { ModalFooterButtonsModule } from '../webmodule-common/other/ui/modal-footer-buttons-lang';
import { ModalHelperModule } from '../webmodule-common/other/ui/modal-helper-lang';
import { ModalImgModule } from '../webmodule-common/other/ui/modal-img-lang';
import { ModalLoadingModule } from '../webmodule-common/other/ui/modal-loading-lang';
import { ModalOptionModule } from '../webmodule-common/other/ui/modal-option-lang';
import { ModalSavingModule } from '../webmodule-common/other/ui/modal-saving-lang';
import { ModalValidationHandlerModule } from '../webmodule-common/other/ui/modal-validationhandler-lang';
import { OfflineModule } from '../webmodule-common/other/ui/offline-lang';
import { OfflineOverlayModule } from '../webmodule-common/other/ui/offline-overlay-lang';
import { OutOfDateQuoteItemHandlerModule } from '../scripts/dealer-franchisee/quotes/data/v6/out-of-date-quote-item-handler-lang';
import { OutOfDateQuoteItemHandlerSafeModeModule } from '../scripts/dealer-franchisee/quotes/data/v6/out-of-date-quote-item-handler-safe-mode-lang';
import { PageNotFoundModule } from '../scripts/dealer-franchisee/pages/page-not-found-lang';
import { PaymentProfileDetailViewModule } from '../scripts/franchisee/view/payment-profile-detail-view-lang';
import { PaymentProfileListTableModule } from '../scripts/franchisee/view/payment-profile-list-table-lang';
import { PaymentProfilePickerModule } from '../scripts/franchisee/view/payment-profile-picker-lang';
import { PaymentProfileViewModule } from '../scripts/franchisee/view/payment-profile-view-lang';
import { PricingModelModule } from '../webmodule-common/pricing/pricing-model-lang';
import { ProjectContainerModule } from '../scripts/projects/data/project-container-lang';
import { ProjectDetailViewModule } from '../scripts/projects/views/project-detail-view-lang';
import { ProjectHelperFunctionsModule } from '../scripts/dealer-franchisee/projects/data/project-helper-functions-lang';
import { ProjectListViewModule } from '../scripts/projects/views/project-list-view-lang';
import { ProjectPickerModule } from '../scripts/projects/project-picker-lang';
import { ProjectUiAdapterModule } from '../scripts/dealer-franchisee/projects/project-ui-adapter-lang';
import { ProjectViewModule } from '../scripts/projects/project-view-lang';
import { PurchaseOrderContainerModule } from '../scripts/purchase-orders/purchase-order-container-lang';
import { PurchaseOrderDetailViewModule } from '../scripts/purchase-orders/purchase-order-detail-view-lang';
import { PurchaseOrderHelperFunctionsModule } from '../scripts/purchase-orders/purchase-order-helper-functions-lang';
import { PurchaseOrderListViewModule } from '../scripts/purchase-orders/purchase-order-list-view-lang';
import { PurchaseOrderSummaryTableModule } from '../scripts/purchase-orders/purchase-order-summary-table-lang';
import { PurchaseOrderUiAdapterModule } from '../scripts/dealer-franchisee/purchase-orders/purchase-order-ui-adapter-lang';
import { PurchaseOrderViewModule } from '../scripts/purchase-orders/purchase-order-view-lang';
import { QuoteContainerModule } from '../scripts/quotes/quote-container-lang';
import { QuoteCreatorModule } from '../scripts/dealer-franchisee/quotes/quote-creator-lang';
import { QuoteDealerPriceAdjustmentDialogModule } from '../scripts/dealer-franchisee/quotes/views/quote-dealer-price-adjustment-dialog-lang';
import { QuoteDetailViewModule } from '../scripts/quotes/views/quote-detail-view-lang';
import { QuoteHelperFunctionsModule } from '../scripts/quotes/quote-helper-functions-lang';
import { QuoteItemCommentModalModule } from '../scripts/quotes/quote-item-comment-modal-lang';
import { QuoteItemPriceAdjustSupplierViewModule } from '../scripts/quotes/views/quote-item-price-adjust-supplier-view-lang';
import { QuoteItemPriceAdjustViewModule } from '../scripts/quotes/views/quote-item-price-adjust-view-lang';
import { QuoteItemValidationModalModule } from '../scripts/quotes/views/quote-item-validation-modal-lang';
import { QuoteItemViewModule } from '../scripts/quotes/views/quote-item-view-lang';
import { QuoteListViewModule } from '../scripts/quotes/views/quote-list-view-lang';
import { QuotePricingmodelAdjustmentDialogModule } from '../scripts/dealer-franchisee/quotes/views/quote-pricingmodel-adjustment-dialog-lang';
import { QuoteStateReasonsModule } from '../scripts/quotes/quote-state-reasons-lang';
import { QuoteSupplierProviderModule } from '../scripts/quotes/quote-supplier-provider-lang';
import { QuoteSupportInboxTableModule } from '../scripts/dealer-franchisee/support-inbox/views/quote-support-inbox-table-lang';
import { QuoteTechnicalReviewConfirmationModule } from '../scripts/quotes/quote-technical-review-confirmation-lang';
import { QuoteUiAdapterModule } from '../scripts/dealer-franchisee/quotes/quote-ui-adapter-lang';
import { QuoteViewModule } from '../scripts/quotes/views/quote-view-lang';
import { ResourceLockModule } from '../scripts/dealer-franchisee/common/resource-lock-lang';
import { SalesSuccessWidgetModule } from '../scripts/dealer-franchisee/dashboard/widget/sales-success-widget-lang';
import { SampleModule } from './sample-lang-module';
import { SaveWorkflowModule } from '../webmodule-common/other/save-workflow-lang';
import { ShippingLineItemViewModule } from '../scripts/quotes/views/shipping-line-item-view-lang';
import { ShowErrorModule } from '../webmodule-common/other/ui/show-error-lang';
import { SpecialLineItemViewModule } from '../scripts/quotes/views/special-line-item-view-lang';
import { StringHelperFunctionsModule } from '../webmodule-common/other/ui/string-helper-functions-lang';
import { SupplierQuoteItemContentTypeModule } from '../scripts/quotes/supplier-quote-item-content-type-lang';
import { SupplierSelectorModule } from '../scripts/dealer-franchisee/quotes/supplier-selector-lang';
import { SupplierServicesModule } from '../scripts/v6config/supplier-services-lang';
import { SupplierTermsAndConditionsModalModule } from '../scripts/dealer-franchisee/supplier/terms-and-conditions-modal-lang';
import { SupportInboxViewModule } from '../scripts/dealer-franchisee/support-inbox/views/support-inbox-view-lang';
import { TimelineWidgetModalModule } from '../scripts/dealer-franchisee/dashboard/widget/timeline-widget-modal-lang';
import { ToastAwayModule } from '../webmodule-common/other/toast-away-lang';
import { UserSessionVerifierModule } from '../webmodule-common/other/user-session-verifier-lang';
import { V6ConfigModule } from '../scripts/v6config/v6config-lang';
import { V6QuoteItemFrameViewModule } from '../scripts/quotes/v6/v6-quote-item-frame-view-lang';
import { V6QuoteSupplierDefaultsViewModule } from '../scripts/quotes/v6/v6-quote-supplier-defaults-view-lang';
import { V6QuoteSupplierGlassViewModule } from '../scripts/quotes/v6/v6-quote-supplier-glass-view-lang';
import { V6SsiProcessorModule } from '../scripts/quotes/v6-ssi-processor-lang';
import { V6SupplierQuoteModule } from '../scripts/quotes/v6-supplier-quote-lang';
import { WmBranchQuoteConversationModule } from '../scripts/dealer-franchisee/conversation/wm-branchquote-conversation-lang';
import { WmBranchQuoteSupportEditorModule } from '../scripts/dealer-franchisee/conversation/wm-branchquote-support-editor-lang';
import { WmBranchQuoteSupportNewModule } from '../scripts/dealer-franchisee/conversation/wm-branchquote-support-new-lang';
import { TermsConditionsPickerModule } from '../scripts/franchisee/view/terms-conditions-picker-lang';
import { TermsConditionsViewModule } from '../scripts/franchisee/view/terms-conditions-view-lang';
import { TermsConditionsListTableModule } from '../scripts/franchisee/view/terms-conditions-list-table-lang';
import { TermsConditionsDetailViewModule } from '../scripts/franchisee/view/terms-conditions-detail-view-lang';
export function getLanguageModules(): ITranslationModule[] {
  const modules: ITranslationModule[] = [];
  modules.push(new AddressEditorModule());
  modules.push(new ApiResponseHandlerModule());
  modules.push(new AppClientPageModule());
  modules.push(new AppClientsPageModule());
  modules.push(new AppConfigModule());
  modules.push(new AppHomeModule());
  modules.push(new AppIndexModule());
  modules.push(new ApplicationInitializationModule());
  modules.push(new AppProjectPageModule());
  modules.push(new AppProjectsPageModule());
  modules.push(new AppPurchaseOrderPageModule());
  modules.push(new AppPurchaseOrdersPageModule());
  modules.push(new AppQuotePageModule());
  modules.push(new AppQuotesPageModule());
  modules.push(new AppResourceBaseModule());
  modules.push(new AppSettingsPageModule());
  modules.push(new AppSupportInboxModule());
  modules.push(new AuthenticateModalLitModule());
  modules.push(new AutoSaveNotifierModule());
  modules.push(new BranchSwitchModule());
  modules.push(new ClientContainerManagerModule());
  modules.push(new ClientDetailViewModule());
  modules.push(new ClientListTableModule());
  modules.push(new ClientPickerModule());
  modules.push(new ClientSummaryPickerModule());
  modules.push(new ClientViewModule());
  modules.push(new ContactContainerManagerModule());
  modules.push(new ContactDetailViewModule());
  modules.push(new ContactListTableModule());
  modules.push(new ContactPickerModule());
  modules.push(new ContactViewModule());
  modules.push(new ContainerManagerModule());
  modules.push(new ConversationHelperModule());
  modules.push(new DashboardBranchMonthlyDeliveryPipelineModule());
  modules.push(new DashboardBranchMonthlyRevenueByStateModule());
  modules.push(new DashboardBranchMonthlyRevenueModule());
  modules.push(new DashboardBranchMonthlyRevenuePipelineModule());
  modules.push(new DashboardBranchMonthlyUserRevenueByStateModule());
  modules.push(new DashboardFilterModule());
  modules.push(new DataEntryScreenBaseModule());
  modules.push(new DealerFranchiseeClientContainerModule());
  modules.push(new DealerFranchiseeClientUiAdaptorModule());
  modules.push(new DealerFranchiseeConversationWmBranchquoteSupportModule());
  modules.push(new DealerFranchiseeConversationWmConversationEntryDropzoneModule());
  modules.push(new DealerFranchiseeConversationWmConversationEntryModule());
  modules.push(new DealerPageloadVerificationsModule());
  modules.push(new DevelopmentErrorModule());
  modules.push(new AppFabricationJobPageModule());
  modules.push(new AppFabricationJobsPageModule());
  modules.push(new EventSourceModule());
  modules.push(new FabricationJobDetailViewModule());
  modules.push(new FabricationJobItemFrameViewModule());
  modules.push(new FabricationJobItemsTableModule());
  modules.push(new FabricationJobListViewModule());
  modules.push(new FabricationJobPickerModule());
  modules.push(new FabricationJobSummaryTableModule());
  modules.push(new FormInputViewModule());
  modules.push(new FranchiseeAppIndexModule());
  modules.push(new FranchiseeBranchEditorModule());
  modules.push(new FranchiseeBrandingViewModule());
  modules.push(new FranchiseeClientDetailViewModule());
  modules.push(new FranchiseeClientListTableModule());
  modules.push(new FranchiseeClientListViewModule());
  modules.push(new FranchiseeConfigurationViewModule());
  modules.push(new FranchiseeEngineeredToOrderViewModule());
  modules.push(new FranchiseeInformationViewModule());
  modules.push(new FranchiseePaymentProfileDetailViewModule());
  modules.push(new FranchiseePaymentProfilePickerModule());
  modules.push(new FranchiseeProjectDetailViewModule());
  modules.push(new FranchiseeProjectDocumentViewModule());
  modules.push(new FranchiseeProjectManagerModule());
  modules.push(new FranchiseeProjectResourceViewModule());
  modules.push(new FranchiseeProjectViewModule());
  modules.push(new FranchiseePurchaseOrderDetailViewModule());
  modules.push(new FranchiseePurchaseOrderSummaryTableModule());
  modules.push(new FranchiseePurchaseOrderViewModule());
  modules.push(new FranchiseeQuoteAddressManagerModule());
  modules.push(new FranchiseeQuoteCreateProjectModalModule());
  modules.push(new FranchiseeQuoteDetailViewModule());
  modules.push(new FranchiseeQuoteItemsViewModule());
  modules.push(new FranchiseeQuoteListViewModule());
  modules.push(new FranchiseeQuoteManagerModule());
  modules.push(new FranchiseeQuoteSupportTicketViewModule());
  modules.push(new FranchiseeQuoteViewModule());
  modules.push(new FranchiseeStaffViewModule());
  modules.push(new FranchiseeStockViewModule());
  modules.push(new FranchiseeSupplierSettingsViewModule());
  modules.push(new FranchiseeV6BomViewerModule());
  modules.push(new FranchiseeV6QuoteViewModule());
  modules.push(new FranchiseeViewModule());
  modules.push(new FreehandLineItemViewModule());
  modules.push(new GeneratedPurchaseOrdersWidgetModule());
  modules.push(new GooglePlaceAutocompleteModule());
  modules.push(new GraphicalFamilyResourcePickerModule());
  modules.push(new IconNotificationSignalModule());
  modules.push(new IndexedDbWrapperModule());
  modules.push(new IssuedQuotesWidgetModule());
  modules.push(new LineItemViewModule());
  modules.push(new LitTableModule());
  modules.push(new LitTableViewModule());
  modules.push(new ModalConfirmationModule());
  modules.push(new ModalConfirmationReasonModule());
  modules.push(new ModalErrorHandlerModule());
  modules.push(new ModalFooterButtonsModule());
  modules.push(new ModalHelperModule());
  modules.push(new ModalImgModule());
  modules.push(new ModalLoadingModule());
  modules.push(new ModalOptionModule());
  modules.push(new ModalSavingModule());
  modules.push(new ModalValidationHandlerModule());
  modules.push(new OfflineModule());
  modules.push(new OfflineOverlayModule());
  modules.push(new OutOfDateQuoteItemHandlerModule());
  modules.push(new OutOfDateQuoteItemHandlerSafeModeModule());
  modules.push(new PageNotFoundModule());
  modules.push(new PaymentProfileDetailViewModule());
  modules.push(new PaymentProfileListTableModule());
  modules.push(new PaymentProfilePickerModule());
  modules.push(new PaymentProfileViewModule());
  modules.push(new TermsConditionsDetailViewModule());
  modules.push(new TermsConditionsListTableModule());
  modules.push(new TermsConditionsPickerModule());
  modules.push(new TermsConditionsViewModule());
  modules.push(new PricingModelModule());
  modules.push(new ProjectContainerModule());
  modules.push(new ProjectDetailViewModule());
  modules.push(new ProjectHelperFunctionsModule());
  modules.push(new ProjectListViewModule());
  modules.push(new ProjectPickerModule());
  modules.push(new ProjectUiAdapterModule());
  modules.push(new ProjectViewModule());
  modules.push(new PurchaseOrderContainerModule());
  modules.push(new PurchaseOrderDetailViewModule());
  modules.push(new PurchaseOrderHelperFunctionsModule());
  modules.push(new PurchaseOrderListViewModule());
  modules.push(new PurchaseOrderSummaryTableModule());
  modules.push(new PurchaseOrderUiAdapterModule());
  modules.push(new PurchaseOrderViewModule());
  modules.push(new QuoteContainerModule());
  modules.push(new QuoteCreatorModule());
  modules.push(new QuoteDealerPriceAdjustmentDialogModule());
  modules.push(new QuoteDetailViewModule());
  modules.push(new QuoteHelperFunctionsModule());
  modules.push(new QuoteItemCommentModalModule());
  modules.push(new QuoteItemPriceAdjustSupplierViewModule());
  modules.push(new QuoteItemPriceAdjustViewModule());
  modules.push(new QuoteItemValidationModalModule());
  modules.push(new QuoteItemViewModule());
  modules.push(new QuoteListViewModule());
  modules.push(new QuotePricingmodelAdjustmentDialogModule());
  modules.push(new QuoteStateReasonsModule());
  modules.push(new QuoteSupplierProviderModule());
  modules.push(new QuoteSupportInboxTableModule());
  modules.push(new QuoteTechnicalReviewConfirmationModule());
  modules.push(new QuoteUiAdapterModule());
  modules.push(new QuoteViewModule());
  modules.push(new ResourceLockModule());
  modules.push(new SalesSuccessWidgetModule());
  modules.push(new SampleModule());
  modules.push(new SaveWorkflowModule());
  modules.push(new ShippingLineItemViewModule());
  modules.push(new ShowErrorModule());
  modules.push(new SpecialLineItemViewModule());
  modules.push(new StringHelperFunctionsModule());
  modules.push(new SupplierQuoteItemContentTypeModule());
  modules.push(new SupplierSelectorModule());
  modules.push(new SupplierServicesModule());
  modules.push(new SupplierTermsAndConditionsModalModule());
  modules.push(new SupportInboxViewModule());
  modules.push(new TimelineWidgetModalModule());
  modules.push(new ToastAwayModule());
  modules.push(new UserSessionVerifierModule());
  modules.push(new V6ConfigModule());
  modules.push(new V6QuoteItemFrameViewModule());
  modules.push(new V6QuoteSupplierDefaultsViewModule());
  modules.push(new V6QuoteSupplierGlassViewModule());
  modules.push(new V6SsiProcessorModule());
  modules.push(new V6SupplierQuoteModule());
  modules.push(new WmBranchQuoteConversationModule());
  modules.push(new WmBranchQuoteSupportEditorModule());
  modules.push(new WmBranchQuoteSupportNewModule());
  return modules;
}
